import { Component } from 'react';

import EditHoldModal from './components/EditHoldModal';

class HoldCancelClub extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: null,
      holdId: null
    };
  }

  handleEditHold = (e) => {
    e.preventDefault();
    const id = e.currentTarget.getAttribute('data-id');
    this.setState({
      modal: 'editHold',
      holdId: id
    });
  };

  handleCloseModal = () => {
    this.setState({
      modal: null,
      holdId: null
    });
  };

  render() {
    const { clubMembership, settings } = this.props;
    const { modal, holdId } = this.state;
    if (clubMembership.status === 'On Hold') {
      const currentHoldId = getCurrentHold(clubMembership);
      return (
        <>
          Your membership is currently on hold.
          <br />
          <br />
          <a
            onClick={this.handleEditHold}
            data-id={currentHoldId}
            className="c7-button-alt-small"
          >
            Remove Hold
          </a>
          <br />
          {renderModal(
            modal,
            this.handleCloseModal,
            clubMembership.id,
            holdId,
            settings
          )}
        </>
      );
    }
    return null;
  }
}

const getCurrentHold = (clubMembership) => {
  let today = new Date();
  today = today.toISOString();
  let currentHoldId = null;
  clubMembership.onHolds.forEach((onHold) => {
    if (onHold.startDate < today && onHold.endDate > today) {
      currentHoldId = onHold.id;
    }
  });
  return currentHoldId;
};

const renderModal = (
  modal,
  handleCloseModal,
  clubMembershipId,
  holdId,
  settings
) => {
  switch (modal) {
    case 'editHold': {
      return (
        <EditHoldModal
          holdId={holdId}
          onCloseModal={handleCloseModal}
          clubMembershipId={clubMembershipId}
          settings={settings}
        />
      );
    }
    default: {
      return null;
    }
  }
};

export default HoldCancelClub;
